module.exports = __webpack_public_path__ + "img/doOrder.562047f5.png";